<template>
  <v-row>
    <v-col
      cols="12"
      md="8"
      class="py-0"
    >
      <v-card class="mb-3">
        <v-toolbar flat>
          <v-toolbar-title>
            Details
          </v-toolbar-title>
        </v-toolbar>
        <v-divider/>
        <v-card-text>
          <v-text-field
            outlined
            dense
            v-model="model.nickname"
            label="Nickname"
            persistent-hint
            hint="This won't be visible to customers, but will help you find this plan later."
            outlined
          />
          <!--            <v-text-field-->
          <!--              v-model="model.id"-->
          <!--              label="ID (optional)"-->
          <!--              persistent-hint-->
          <!--              hint="This will identify this plan in the API. We recommend leaving this blank so we can generate an ID for you."-->
          <!--              outlined-->
          <!--            ></v-text-field>-->
        </v-card-text>
      </v-card>

      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>
            Pricing
          </v-toolbar-title>
        </v-toolbar>
        <v-divider/>
        <v-card-text>

          <v-row>
            <v-col cols="6">
              <currency-select
                disabled
                :init="model.currency"
                @change="(val) => { model.currency = val }"
              />
            </v-col>
            <v-col cols="6">
              <amount-input
                :init-amount="parseInt(model.amount, 10)"
                @change="(val) => { model.amount = val}"
              />
              <!--              <v-text-field-->
              <!--                v-model="model.amount"-->
              <!--                label="Price per unit"-->
              <!--                :prefix="amountPrefix"-->
              <!--              />-->
            </v-col>
            <v-col cols="12">
              <tax-rate-drop-down
                :init-tax-rates="[]"
                :multiple="true"
                @select-item="onSelectTaxRates"
              />
            </v-col>
            <v-col cols="6">
              <v-select
                outlined
                dense
                v-model="model.interval"
                label="Interval"
                :items="billingIntervals()"
                item-value="id"
                item-text="label"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="model.interval_count"
                label="Interval count"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="model.trial_period_days"
                label="Trial Period"
                hint="Subscriptions to this plan will automatically start with a free trial of this length."
                persistent-hint
                suffix="days"
              />
            </v-col>
          </v-row>


        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12">
      <v-divider class="my-3"/>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          rounded
          text
          outlined
          :disabled="isLoading"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="isLoading"
          :disabled="isLoading"
          rounded
          color="primary"
          outlined
          @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>

    </v-col>
  </v-row>
</template>
<script>
import { mapActions } from 'vuex'
import CurrencySelect from '@/components/Common/CurrencySelect'
import AmountInput from "../Common/AmountInput"
import TaxRateDropDown from "../TaxRate/TaxRateDropDown"

export default {
  components: {
    TaxRateDropDown,
    AmountInput,
    CurrencySelect
  },
  computed: {
    amountPrefix() {
      return `${this.model.currency} -`.toUpperCase()
    }
  },
  methods: {
    ...mapActions([ 'createPlan' ]),
    billingIntervals() {
      return [
        {
          id: 'day',
          label: 'Day',
        },
        {
          id: 'week',
          label: 'Week',
        },
        {
          id: 'month',
          label: 'Month',
        },
        {
          id: 'year',
          label: 'Year',
        }
      ]
    },
    onSelectTaxRates(taxes) {
      this.model.metadata.default_tax_rates = [ ...taxes]
    },
    selectedCurrency(currency) {
      this.model.currency = currency
    },
    save() {
      const payload = { ...this.model }

      this.isLoading = true
      this.createPlan(payload)
        .then(plan => {
          this.$router.push({
            name: 'service-detail',
            params: {
              id: plan.product
            }
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  data() {
    return {
      isLoading: false,
      model: {
        product: this.$route.params.productId,
        nickname: undefined,
        amount: 0,
        currency: 'cad',
        interval: 'month',
        interval_count: 1,
        trial_period_days: 0,
        metadata: {
          default_tax_rates: []
        }
      },
      discountType: '',

    }
  },
}
</script>
